import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { OnscreenNotificationService } from './onscreen-notification.service';

@Component({
  selector: 'fleet-onscreen-notification',
  templateUrl: './onscreen-notification.component.html',
  styleUrls: ['./onscreen-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnscreenNotificationComponent implements OnInit {
  @Input() notifications: any[];
  @Output() closeNotification = new EventEmitter();
  constructor(
    private notificationService: OnscreenNotificationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.notificationService.notification$.subscribe({
      next: (notifications) => {
        this.notifications = notifications;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  close(notification: any) {
    this.notificationService.removeNotification(notification);
  }
}
